import { authStorage } from 'storages/authStorage';
import { goToAuth, onRefreshTokensFx } from 'app/services/AuthService/helpers';
import { isAccessTokenExpires } from 'app/services/AuthService/config';
import { AuthenticationError, getErrorMessage } from 'shared/errors';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';

export const checkCurrentAuth = async (
  authConfig: AuthConfigInterface,
): Promise<void> => {
  try {
    const jwtAuthParams = authStorage.getJwtAuthParams();

    if (!jwtAuthParams || !jwtAuthParams.access || !jwtAuthParams.refresh) {
      if (authConfig.allowAnonymous) return Promise.reject();

      return goToAuth(authConfig);
    }

    if (isAccessTokenExpires(jwtAuthParams.access))
      return await onRefreshTokensFx(jwtAuthParams.refresh, authConfig);

    return Promise.resolve();
  } catch (error) {
    const pref = 'CheckCurrentAuth: ';
    const errorMessage = getErrorMessage(`${pref}${error}`);

    if (errorMessage) throw new Error(errorMessage);

    throw new AuthenticationError('Catch error while check current authorization!');
  }
};
